'use client'

import TabPanel from "components/TabPanel";
import TabView from "components/TabView";
import { useEffect, useMemo, useState } from "react";
import { Button, Col, Container, FormGroup, Input, Label, Row } from "reactstrap";
import Dados from "./Dados";
import Responsaveis from "./Responsaveis";
import Prepostos from "./Prepostos";
import { validate } from "components/validateGeneralForm";
import TitleFormWithEdit from "components/TitleFormWithEdit";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import empresaService from "services/EmpresaService";
import { toast } from "react-toastify";
import { erroInesperado } from "services/Utils";
import estadoService from "services/EstadoService";
import CustomDropzone from "components/CustomDropzone";
import arquivoService from "services/ArquivoService";
import Equipes from "./Equipes";

export default function FormEmpresa() {
  const [data, setData] = useState({})
  const [edit, setEdit] = useState(false)
  const [arquivo, setArquivo] = useState(null)
  const [estados, setEstados] = useState([])
  const params = useParams()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const id = parseInt(params.id)
  const novo = (0 === id)

  useEffect(() => {
    setEstados(estadoService.get())
  }, [])

  useEffect(() => {
    if (!!id) {
      empresaService.getById(id).then(res => {
        if (res.success) {
          setData(res.data)
        }
      })
    } else {
      setData({})
    }
  }, [id])

  useEffect(() => {
    if (novo) {
      setEdit(true)
    }
  }, [novo])

  const formConfig = useMemo(() => {
    return [
      [
        { name: "cnpj", label: 'CNPJ', type: "cnpj", required: true, colspan: 4 },
        { name: "razaoSocial", label: 'Razão Social', type: "text", required: true, colspan: 8 },
        { name: "nomeFantasia", label: 'Nome Fantasia', type: "text", required: true, colspan: 8 },
        { name: "nomeCurto", label: 'Nome para exibição', type: "text", required: false, colspan: 4 },
      ],
      [
        { name: "cep", label: 'CEP', type: "cep", required: true, colspan: 2 },
        { name: "logradouro", label: 'Endereço', type: "text", required: true, colspan: 8 },
        { name: "numero", label: 'Número', type: "text", required: true, colspan: 2 },
        { name: "complemento", label: 'Complemento', type: "text", required: false, colspan: 2 },
        { name: "bairro", label: 'Bairro', type: "text", required: true, colspan: 4 },
        { name: "cidade", label: 'Cidade', type: "text", required: true, colspan: 4 },
        { name: "uf", label: 'UF', type: "combo", options: estados.map(el => ({ value: el.sigla, label: el.nome })), showDefault: true, required: true, colspan: 2 },
      ], [
        { name: "telefone", label: 'Telefone', type: "phone", required: true, colspan: 4 },
        { name: "email", label: 'E-mail', type: "text", required: true, colspan: 8 },
        { name: "visto", label: 'Visto medição', type: "text", required: false, colspan: 6 },
      ], [
        {
          name: "logo",
          type: "view",
          required: false,
          colspan: 6,
          component: () => {
            console.log({
              arquivo,
              logo: data.logo
            })
            if (arquivo || data.logo) {
              const nomeArquivo = arquivo ? arquivo.name : data.logo.nomeArquivo
              const funcaoExcluir = arquivo ? () => handleChangeLogo(null) : () => handleChange('logo', null)
              return (
                <Row>
                  <Col xs={8}>
                    <FormGroup>
                      <Label>Logo</Label>
                      <Input type="text" value={nomeArquivo} disabled={true} />
                    </FormGroup>
                  </Col>
                  <Col xs={4} className="d-flex align-items-end">
                    {edit && (
                      <FormGroup>
                        <Button color="danger" outline onClick={funcaoExcluir}>
                          Excluir
                        </Button>
                      </FormGroup>
                    )}
                  </Col>
                </Row>
              )
            }
            return (
              <>
                <div>Logo</div>
                <CustomDropzone
                  onChange={value => handleChangeLogo(value)}
                  onRemove={() => handleChangeLogo(null)}
                  edit={edit}
                />
              </>
            )
          }
        },
      ]
    ]
  }, [estados, edit, arquivo, data])

  const handleChange = (field, value) => {
    setData({ ...data, [field]: value })
  }

  const handleChangeLogo = (value) => {
    if (!value) {
      setData({ ...data, logo: null })
    }
    setArquivo(value)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    try {

      if (arquivo) {
        const res = await arquivoService.upload(arquivo)
        if (res.success) {
          data.logo = { id: res.data }
        } else {
          toast('Erro ao enviar arquivo')
          return
        }
      }

      if (novo) {
        await empresaService.create(data)
      } else {
        await empresaService.update(id, data)
      }
      toast('Registro salvo com sucesso!')
      navigate('/admin/empresas')
    } catch (ex) {
      erroInesperado()
    }

  }

  return (
    <Container fluid>
      <TitleFormWithEdit title="Empresas" edit={edit} onChangeEdit={setEdit} showButton={!novo} />

      <TabView defaultTab={searchParams.get('aba') == 'equipes' ? 4 : 1}>
        <TabPanel label="Dados">
          <form onSubmit={handleSubmit}>
            <Dados data={data} onChange={handleChange} formConfig={formConfig} edit={edit} />
            {edit && (
              <div className="text-right">
                <Button type="submit" color="primary">Salvar</Button>
              </div>
            )}
          </form>
        </TabPanel>
        <TabPanel label="Responsáveis">
          <Responsaveis edit={edit} idEmpresa={id} />
        </TabPanel>
        <TabPanel label="Prepostos">
          <Prepostos edit={edit} idEmpresa={id} />
        </TabPanel>
      </TabView>
    </Container>
  )
}